import React from "react"
import styled from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo"


const TextBox = styled.div`
display: flex;
flex-direction: column;
width: 1000px;
margin: 0 auto;

@media (max-width: 1024px) {
  width: 80%

}
`
const Gap = styled.div`
height: 2rem;

  @media (max-width: 1024px) {
  
  }
`

const termsMetadata = {
  Title: "Terms & Conditions | Predicta S.A.",
  Keywords: [`covid analytics`,`predicta analytics`, `covid`, `predicta`],
  Description: "Terms & Conditions for the Predicta4Covid.com microsite displaying the results of a statistical analysis",
  Image: "/predicta-icon.png",
  url:"https://www.predicta4covid.com/",
  titleTemplate:"Terms & Conditions | Predicta S.A."
}

const Terms = (props) => (
    <Layout location={props.location}>
    <SEO 
      title={termsMetadata.Title} 
      keywords={termsMetadata.Keywords} 
      description={termsMetadata.Description} 
      image={termsMetadata.Image}
      url={termsMetadata.url}
      titleTemplate={termsMetadata.titleTemplate}
    />
<div className="row" id="first-section">
    <div className="col">
      
     <h1>Terms & Conditions</h1>

     <Gap/>

  

<TextBox>
Date: March 26, 2021
<h2>Overview</h2>
<p>The following are the terms of an agreement between you and PREDICTA. By accessing, 
  or using this Web site, you acknowledge that you have read, understand, and agree 
  to be bound by these terms and to comply with all applicable laws and regulations, 
  including export and re-export control laws and regulations. If you do not agree to 
  these terms, please do not use this Website. PREDICTA may, without notice to you, at 
  any time, revise these Terms of Use and any other information contained in this Website. 
  PREDICTA may also make improvements or changes in the products, services, or programs 
  described in this site at any time without notice.</p>
<h2>General</h2>
<p>
  This Website contains proprietary notices and copyright information, the terms of which must 
  be observed and followed. Please see the tab entitled “Copyright and trademark information” 
  for related information.PREDICTA grants you a non-exclusive, non-transferable, limited permission 
  to access and display the Webpages within this site as a customer or potential customer of PREDICTA 
  provided you comply with these Terms of Use, and all copyright, trademark, and other proprietary 
  notices remain intact. You may only use a crawler to crawl this Website as permitted by this 
  Website’s robots.txt protocol, and PREDICTA may block any crawlers in its sole discretion. 
  The use authorized under this agreement is non-commercial in nature (e.g., you may not sell the 
  content you access on or through this Web site.) All other use of this site is prohibited.
</p>
<p>
  Except for the limited permission in the preceding paragraph, PREDICTA does not grant you any 
  express or implied rights or licenses under any patents, trademarks, copyrights, or other proprietary 
  or intellectual property rights. You may not mirror any of the content from this site on another Website 
  or in any other media. Any software and other materials that are made available for downloading, access, 
  or other use from this site with their own license terms will be governed by such terms, conditions, 
  and notices. Your failure to comply with such terms or any of the terms on this site will result in 
  automatic termination of any rights granted to you, without prior notice, and you must immediately 
  destroy all copies of downloaded materials in your possession, custody, or control.
</p>
<h2>Disclaimer</h2>
<p>
  From time to time, this Website may contain technical inaccuracies or typographical errors, and we do not 
  warrant the accuracy of any posted information. Please confirm you are using the most up-to-date pages on 
  this Website and confirm the accuracy and completeness of information before using it to make decisions 
  relating to services, products, or other matters described in this Website.
  If any term in this Terms of Use is found by competent judicial authority to be unenforceable in any 
  respect, the validity of the remainder of this Terms of Use will be unaffected, provided that such 
  unenforceability does not materially affect the parties’ rights under this Terms of Use.

</p>
<h2>
  Confidential information
</h2>
<p>
  PREDICTA does not want to receive confidential or proprietary information from you through our Website. 
  Please note that any information or material sent to PREDICTA will be deemed NOT to be confidential. 
  By sending PREDICTA any information or material, you grant PREDICTA an unrestricted, irrevocable license 
  to copy, reproduce, publish, upload, post, transmit, distribute, publicly display, perform, modify, 
  create derivative works from, and otherwise freely use, those materials or information. You also agree 
  that PREDICTA is free to use any ideas, concepts, know-how, or techniques that you send us for any purpose. 
  However, we will not release your name or otherwise publicize the fact that you submitted materials or 
  other information to us unless: (a) we obtain your permission to use your name; or (b) we first notify 
  you that the materials or other information you submit to a particular part of this site will be published 
  or otherwise used with your name on it; or (c) we are required to do so by law. Personally-identifiable 
  information that you submit to PREDICTA for the purpose of receiving products or services will be handled 
  in accordance with our privacy policies. Please see the page entitled “Privacy Policy” for information 
  regarding  PREDICTA’s privacy policies.
</p>

<h2>
  Global availability
</h2>
<p>
  Information PREDICTA publishes on the Internet may contain references or cross references to PREDICTA 
  products, programs and services that are not announced or available in your country. Such references 
  do not imply that PREDICTA intends to announce or make available such products, programs, or services 
  in your country. Please consult your local PREDICTA business contact for information regarding the 
  products, programs, and services that may be available to you.
</p>

<h2>
  Business relationships
</h2>
<p>
  This Web site may provide links or references to non-PREDICTA Web sites and resources. PREDICTA makes no 
  representations, warranties, or other commitments or endorsements whatsoever about any non-PREDICTA 
  Websites or third-party resources (including any Lenovo Website) that may be referenced, accessible 
  from, or linked to any PREDICTA site. In addition, PREDICTA is not a party to or responsible for any 
  transactions you may enter into with third parties, even if you learn of such parties (or use a link 
  to such parties) from  PREDICTA site. When you access a non-PREDICTA Website, even one that may contain 
  the PREDICTA-logo, please understand that it is independent from PREDICTA, and that PREDICTA does not 
  control the content on that Web site. It is up to you to take precautions to protect yourself from viruses, 
  worms, Trojan horses, and other potentially destructive programs, and to protect your information.
</p>

<h2>
  Linking to this site
</h2>

<p>
  PREDICTA consents only to links to this Website in which the link and the pages that are activated by the 
  link do not: (a) create frames around any page on this Website or use other techniques that alter in any 
  way the visual presentation or appearance of any content within this site; (b) misrepresent your relationship
  with PREDICTA; (c) imply that PREDICTA approves or endorses you, your Website, or your service or product 
  offerings; and (d) present false or misleading impressions about PREDICTA or otherwise damage the goodwill
  associated with the PREDICTA name or trademarks. As a further condition to being permitted to link to this
  site, you agree that PREDICTA  may at any time, in its sole discretion, terminate permission to link to
  this Website. In such event, you agree to immediately remove all links to this Web site and to cease any
  related use of PREDICTA trademarks. 
</p>

<h2>
  Disclaimer of warranty
</h2>
<p>
  Use of this site is at your sole risk. All materials, information, products, software, programs, and services 
  are provided "as is," with no warranties or guarantees whatsoever. PREDICTA expressly disclaims to the fullest
  extent permitted by law all express, implied, statutory, and other warranties, guarantees, or representations, 
  including, without limitation, the warranties of merchantability, fitness for a particular purpose, and non-infringement
  of proprietary and intellectual property rights. Without limitation, IBM makes no warranty or guarantee that 
  this web site will be uninterrupted, timely, secure, or error-free.You understand and agree that if you 
  download or otherwise obtain materials, information, products, software, programs, or services from this 
  web site, you do so at your own discretion and risk and that you will be solely responsible for any damages 
  that may result, including loss of data or damage to your computer system. Some jurisdictions do not allow 
  the exclusion of warranties, so the above exclusions may not apply to you.

</p>

<h2>
  Limitation of liability
</h2>

<p>
  To the fullest extent permitted by applicable law, in no event will PREDICTA be liable to any party for 
  any direct, indirect, incidental, special, exemplary or consequential damages of any type whatsoever 
  related to or arising from this website or any use of this website, or of any site or resource linked to, 
  referenced, or accessed through this website, or for the use or downloading of, or access to, any materials, 
  information, products, or services, including, without limitation, any lost profits, business interruption, 
  lost savings or loss of programs or other data, even if PREDICTA is expressly advised of the possibility 
  of such damages. This exclusion and waiver of liability applies to all causes of action, whether based
   on contract, warranty, tort, or any other legal theories.
</p>



    </TextBox>

    </div>
    </div>


</Layout>
)

export default Terms
